import { CacheService } from './cache.service';

export type EmojiDefinition = {
    emoji: string;
    name: string;
};

export type EmojiCollection = EmojiDefinition[];

export type EmojiByGroup = { [group: string]: EmojiCollection };

const DEFAULT_EMOJI_FREQUENTLY_USED = ['grinning face', 'rolling on the floor laughing'];

export class EmojiProviderService {
    static $inject = ['$http', 'CacheService'];
    private static CACHE_KEY = 'emoji_json';
    private static CACHE_KEY_FREQUENTLY_USED = 'emoji_frequently_used';

    emojiRequest$?: Rx.Observable<EmojiByGroup>;

    constructor(private $http: ng.IHttpService, private cache: CacheService) {}

    private getEmojiRequest$() {
        if (!this.emojiRequest$) {
            this.emojiRequest$ = Rx.Observable.fromPromise(
                this.$http.get<EmojiByGroup>('/static/emoji.json').then((response) => response.data)
            ).shareReplay(1);
        }
        return this.emojiRequest$;
    }

    public getEmoji$() {
        return this.cache.cached$(EmojiProviderService.CACHE_KEY, this.getEmojiRequest$());
    }

    public getFrequentlyUsed() {
        return this.cache.fromCache(EmojiProviderService.CACHE_KEY_FREQUENTLY_USED, DEFAULT_EMOJI_FREQUENTLY_USED);
    }

    public addFrequentlyUsed(emoji: EmojiDefinition) {
        const current = this.cache.fromCache(EmojiProviderService.CACHE_KEY_FREQUENTLY_USED, []);

        const { name } = emoji;

        // do not save duplicate values
        if (current.includes(name)) {
            return;
        }

        this.cache.toCache(EmojiProviderService.CACHE_KEY_FREQUENTLY_USED, [...current, emoji.name]);
    }
}

angular.module('tradersyard').service('EmojiProviderService', EmojiProviderService);
